import React from 'react';
import './StatusFilter.scss';

interface StatusStat {
  status: string;
  count: number;
  label: string;
}

interface StatusFilterProps {
  statusStats: StatusStat[];
  selectedStatus: string[];
  onStatusClick: (status: string) => void;
  onClearAll: () => void;
}

const StatusFilter: React.FC<StatusFilterProps> = ({
  statusStats,
  selectedStatus,
  onStatusClick,
  onClearAll
}) => {
  const hasManyItems = statusStats.length > 4; // Trigger wrapping when 5+ items
  const hasSelectedFilters = selectedStatus.length > 0;
  return (
    <div className="status-filter-container">
      <div className="filter-header">
        <span className="filter-title">Results</span>
      </div>
      <div className={`status-filter ${hasManyItems ? 'many-items' : ''}`}>
        <div className="status-items">
          {statusStats.map((stat) => {
            const isSelected = selectedStatus.includes(stat.status);
            return (
              <div className={`${isSelected ? 'selected-underline' : ''}`}>
                <div
                  className={`status-item ${stat.status.toLowerCase()} `}
                  onClick={() => onStatusClick(stat.status)}
                  title={`${stat.label}`} // Tooltip for accessibility
                >
                  <span className="status-count">{stat.count}</span>
                </div>
              </div>
            );
          })}
          
          {/* Clear button - only disable the clear button, not status items */}
          {hasSelectedFilters &&
          <button 
            className={`clear-button`}
            onClick={onClearAll}
            title={hasSelectedFilters ? "Clear all filters" : "No filters to clear"}
            disabled={!hasSelectedFilters}
          >
          
            <span className="icon-24-close-mono"></span>
          </button>
          }
        </div>
      </div>
    </div>
  );
};

export default StatusFilter;
